import { combineReducers, configureStore, type PreloadedState } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';

import appReducer from '../sites/demoService/reducer';

export const rootReducer = combineReducers({
    app: appReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

export const getStore = (preloadedState?: PreloadedState<RootState>) =>
    configureStore({
        reducer: rootReducer,
        preloadedState,
        devTools: { name: 'rio-uikit-demo' },
    });

export type RootStore = ReturnType<typeof getStore>;
export type AppDispatch = RootStore['dispatch'];

export const store = getStore();

setupListeners(store.dispatch);
